import React, { Component } from 'react';
import { connect } from 'react-redux';

import { saveDiscoAdsCreatorStep } from '../../../actions/DiscoAdsActions';
import { getIntents } from '../selectors/pageStateSelectors';

import DiscoAdsCreatorViewComponentWrapper from '../DiscoAdsComponents/CreatorComponents/DiscoAdsCreatorViewComponentWrapper';
import DiscoAdsCreatorFormSection from '../DiscoAdsComponents/CreatorComponents/DiscoAdsCreatorFormSection';
import DiscoAdsTokenizedIntents from '../DiscoAdsComponents/CreatorComponents/DiscoAdsTokenizedIntents';
import DiscoAdsIntentsModal from '../DiscoAdsComponents/CreatorComponents/DiscoAdsIntentsModal';

import {
  DA_CREATOR_FORM_SECTION_COPY,
  STEPPER_CARD_COMPLETE_STEP,
  DA_INTENTS_SETUP
} from '../discoAdsConstants';

const formWrapperCustomStyles = {
  formContainer: {
    marginLeft: '50px',
    marginRight: '50px',
    marginTop: '40px',
    marginBottom: '24px',
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    width: '800px'
  }
};

class DiscoAdsCreateIntents extends Component {
  state = {
    intents: this.props.intents,
    showIntentsModal: false
  };

  componentDidUpdate(prevProps) {
    const { intents } = this.props;
    if (prevProps.intents !== intents) {
      this.setState({ intents });
    }
  }

  _onOpenCloseIntentsModal = () => {
    this.setState({ showIntentsModal: !this.state.showIntentsModal });
  };

  _onSaveSelectedIntentsInModal = selectedIntents => {
    this.props.saveDiscoAdsCreatorStep({
      stepKey: DA_INTENTS_SETUP,
      payload: { intents: [...selectedIntents] }
    });
  };

  _onRemoveIntent = removedIntentId => {
    const remainingIntents = this.state.intents.filter(
      intent => intent.id !== removedIntentId
    );
    this.setState({ intents: remainingIntents });
  };

  _onSaveAndContinueClick = () => {
    const {
      onCompletionStatusChange,
      onNext,
      saveDiscoAdsCreatorStep
    } = this.props;
    saveDiscoAdsCreatorStep({
      stepKey: DA_INTENTS_SETUP,
      payload: { intents: [...this.state.intents] }
    });
    onCompletionStatusChange(STEPPER_CARD_COMPLETE_STEP);
    onNext();
  };

  render() {
    const {
      intents: { intents: intentsCopy }
    } = DA_CREATOR_FORM_SECTION_COPY;
    const { showIntentsModal } = this.state;
    return (
      <DiscoAdsCreatorViewComponentWrapper
        saveAndContinueButtonIsDisabled={!this.state.intents.length}
        onSaveClick={this._onSaveAndContinueClick}
        customStyles={formWrapperCustomStyles}
        onCancelClick={this.props.onCancel}
      >
        <DiscoAdsCreatorFormSection
          title={intentsCopy.title}
          subtitle={intentsCopy.subtitle}
          component={() => (
            <DiscoAdsTokenizedIntents
              intents={this.state.intents}
              onOpenCloseIntentsModal={this._onOpenCloseIntentsModal}
              onRemoveIntent={this._onRemoveIntent}
            />
          )}
        />
        {showIntentsModal && (
          <DiscoAdsIntentsModal
            showIntentsModal={showIntentsModal}
            onOpenCloseIntentsModal={this._onOpenCloseIntentsModal}
            onSaveSelectedIntents={this._onSaveSelectedIntentsInModal}
            selectedIntents={this.state.intents}
          />
        )}
      </DiscoAdsCreatorViewComponentWrapper>
    );
  }
}

const mapStateToProps = state => ({
  intents: getIntents(state)
});

const mapDispatchToProps = dispatch => {
  return {
    saveDiscoAdsCreatorStep: ({ stepKey, payload }) => {
      dispatch(saveDiscoAdsCreatorStep({ stepKey, payload }));
    }
  };
};

const ConnectedDiscoAdsCreateIntents = connect(
  mapStateToProps,
  mapDispatchToProps
)(DiscoAdsCreateIntents);

export default ConnectedDiscoAdsCreateIntents;
